export const repeats = [
  { name: $localize`Weekly`, value: 1 },
  { name: $localize`Monthly`, value: 2 },
  { name: $localize`Yearly`, value: 3 },
]

export const statuses = [
  { name: $localize`Paid`, value: 2 },
  { name: $localize`Unpaid`, value: 1 },
]

export const methods = [
  { name: $localize`Bank Deposit`, value: 'bankdeposit' },
  { name: $localize`Card`, value: 'card' },
  { name: $localize`Cash`, value: 'cash' },
  { name: $localize`Check`, value: 'check' },
  { name: $localize`Credit`, value: 'credit' },
  { name: $localize`Wire Transfer`, value: 'wiretransfer' },
  { name: $localize`Other`, value: 'other' },
]

export const categories = [
  { name: $localize`Food/Beverage`, value: 'Food/Beverage' },
  { name: $localize`Gardening`, value: 'Gardening' },
  { name: $localize`Housekeeping`, value: 'Housekeeping' },
  { name: $localize`Maintenance`, value: 'Maintenance' },
  { name: $localize`Mortgage/Rent`, value: 'Mortgage/Rent' },
  { name: $localize`Pool`, value: 'Pool' },
  { name: $localize`Plumbing`, value: 'Plumbing' },
  { name: $localize`Transportation`, value: 'Transportation' },
  { name: $localize`Utility`, value: 'Utility' },
  { name: $localize`Other`, value: 'Other' },
]
